<div fxLayout="column" *ngIf="leaseId">

  @if (showSection(LeaseViewSection.HEADER)) {
    <app-page-header (tabsChangeEvent)="changeTabs($event)"
                     [description]="'This is your lease schedule summarising the lease terms of the retailers lease categorised according to their current lease status.'"
                     [isTabbed]="isTabbed"
                     [section]="'Lease View'"
                     [selectedTab]="getInitialTab()"
                     [tabs]="tabs"
                     [title]="'View specific lease information'"
    ></app-page-header>
  }


  <div fxLayout="column" [class.page-padding]="!embedded" [class.page-content]="!embedded">

    <div *ngIf="activeTab == 'lease_details'" fxLayout="column">

      @if (showSection(LeaseViewSection.DETAILS) && leaseId) {
        <app-lease-details [id]="leaseId" [offering]="offering!" [reload]="reloadSubject.asObservable()"
                           (updateLeaseStatus)="updateLeaseStatus.emit()"
                           (reloadPos)="reloadPosSettings()"></app-lease-details>

        <mat-divider fxFlexOffset="30px"></mat-divider>
      }

      @if (showSection(LeaseViewSection.SUB_LEASES) && leaseId && isHeadLease) {
        <app-lease-sub-leases [id]="leaseId" [offering]="offering!" (reloadLease)="reloadLeaseDetails()">
        </app-lease-sub-leases>

        <mat-divider fxFlexOffset="30px" *ngIf="leaseId && isHeadLease"></mat-divider>
      }

      @if ((showSection(LeaseViewSection.RATES_AND_CHARGES) || showSection(LeaseViewSection.SPACES)) && leaseId) {
        <app-lease-space-rates [id]="leaseId" [offering]="offering!" [showRates]="true"
                               [isSubLease]="isSubLease"
                               (reloadLease)="reloadLeaseDetails()"></app-lease-space-rates>

        <mat-divider fxFlexOffset="30px" *ngIf="leaseId"></mat-divider>
      }

      @if (showSection(LeaseViewSection.DOCUMENTS) && leaseId) {
        <app-lease-documents [id]="leaseId"></app-lease-documents>

        <mat-divider fxFlexOffset="30px"></mat-divider>
      }

      @if (showSection(LeaseViewSection.POINT_OF_SALE) && leaseId) {
        <app-lease-pos-settings #posSettingsComponent [reload]="reloadPosSubject.asObservable()"
                                (reloadLease)="reloadLeaseDetails()" [id]="leaseId"
                                [offering]="offering!"></app-lease-pos-settings>
      }
    </div>

    @if (showSection(LeaseViewSection.SHOWCASE) && leaseId) {
      <div *ngIf="activeTab == 'lease_showcase'" fxLayout="column">
        <app-lease-showcase [id]="leaseId" [offeringId]="offering!.offeringUuid"></app-lease-showcase>
      </div>
    }

    @if (showSection(LeaseViewSection.TURNOVER) && leaseId) {
      <div *ngIf="activeTab == 'lease_turnover'" fxLayout="column">
        <app-lease-turnover [id]="leaseId" [offeringId]="offering!.offeringUuid"></app-lease-turnover>
      </div>
    }

  </div>

</div>
